import React, { useState, useEffect } from "react";
import moment from "moment";
import _ from 'lodash';
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { DateRangePicker, DateRangeDelimiter, TimePicker, DateTimePicker } from "@material-ui/pickers";
import {
  withStyles,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import * as Var from "styles/variables";
import {
  setDateRangePicTree,
  getHomePictreeCheckInNtt,
  getHomePictreePhotoShootNtt,
  getPictreeDataCheckInTrendNtt,
  getPictreeDataPhotoShootTrendNtt,
  getPictreeDataPhotoDenchuKaisuTrend,
  getInGameItemSalesByOccurrence,
  getPhotoShootMapDataNtt,
  getPictreePhotoShootByAssetNtt,
  getPictreePhotoShootTrendByAssetNtt,
  getPointOverviewDataPicTree,
  getPointTrendDataPicTree,
  getRewardCoinSummary,
  getRewardCoinRankingData,
  getRewardedCoinData,
  getPhotoShootRankingData,
  getPhotoFirstShootRankingData,
  getSeasonRankingData,
  getAreaRankingData,
  setTimeRangePicTree,
  getPicTreeGoldChestTrend,
  getPicTreeRainbowListDetail,
  getPicTreeReviewMethodBySeason,
  getHomePictreeUser,
  getPictreeDataRegistTrend,
  setSelectedSeason,
  getSalesOverviewDataPicTree,
} from "actions";
import PeriodAll from "components/PicTree/Filter/PeriodAll";

const useStyles = makeStyles((theme) =>
  createStyles({
    calendarWrapper: {
      paddingLeft: 8,
      flexGrow: 1,
    },
    root: {
      backgroundColor: "#fafafa",
      zIndex: 1000,
      paddingTop: 16,
      paddingLeft: 8,
      marginTop: -12,
    },
    container: {
      display: "flex",
      maxWidth: 600,
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      alignItems: "baseline",
    },
    delimiter: {
      paddingTop: theme.spacing(1),
    },
    dataBtn: {
      marginTop: theme.spacing(1.2),
      marginLeft: theme.spacing(1),
      height: theme.spacing(4),
      color: Var.btnLabelColor,
    },
    grow: {
      flexGrow: 1,
    },
    sectionCalendar: {
      display: "flex",
      marginRight: theme.spacing(1),
    },
    picTreePredefined: {
      marginRight: theme.spacing(2),
    },
    dateField: {
      width: 120,
      marginLeft: theme.spacing(1),
    },
    timeField: {
      width: 120,
      marginLeft: theme.spacing(1),
    },
  })
);

const CalendarRangePickerAll = ({
  page,
  dateRangePicTree,
  dateRangePicTreeMinMax,
  currentPage,
  setDateRangePicTree,
  setSelectedSeason,
  getPointOverviewDataPicTree,
  getPointTrendDataPicTree,
  getRewardCoinSummary,
  getRewardCoinRankingData,
  getRewardedCoinData,
  getPhotoShootRankingData,
  getPhotoFirstShootRankingData,
  getSeasonRankingData,
  getAreaRankingData,
  setTimeRangePicTree,
  timeselect = false,
  singleSelect = false,
  maxRange = null,
  timeRangePicTree,
  getPicTreeGoldChestTrend,
  getPicTreeRainbowListDetail,
  getPicTreeReviewMethodBySeason,
  getHomePictreeUser,
  getPictreeDataRegistTrend,
  allSeasonData,
  mDate,
  allowOutOfSeason = false,
  getSalesOverviewDataPicTree,
}) => {
  const classes = useStyles();
  const [dateRangeValue, setDateRangeValue] = useState([null, null]);
  const [error, setError] = useState([null, null]);
  const [minDate, setMinDate] = useState(
    mDate
      ? moment(mDate).format("YYYY/MM/DD")
      : moment("2024-12-07").tz("Asia/Tokyo").format("YYYY/MM/DD")
  );
  const [maxDate, setMaxDate] = useState(
    allowOutOfSeason
      ? moment().tz("Asia/Tokyo").format("YYYY/MM/DD")
      : moment("2025-01-12").tz("Asia/Tokyo").format("YYYY/MM/DD")
  );
  const [startTime, setStartTime] = useState("09:00");
  const [endTime, setEndTime] = useState("18:00");

  const today = moment().tz("Asia/Tokyo").format("YYYY-MM-DD HH:mm");
  const todayFormatted = moment(today).format("YYYY-MM-DD");

  useEffect(() => {
    const currentJstDate = moment().tz("Asia/Tokyo").format("YYYY/MM/DD");
    handleHomeCalendar(currentJstDate);
  }, []);

  useEffect(() => {
    if (!allowOutOfSeason) return;

    const minDateValue = mDate
      ? moment(mDate).format("YYYY/MM/DD")
      : moment("2024-12-07").tz("Asia/Tokyo").format("YYYY/MM/DD");
    const maxDateValue = moment().tz("Asia/Tokyo").format("YYYY/MM/DD");
    setMinDate(minDateValue);
    setMaxDate(maxDateValue);
  }, [allowOutOfSeason, mDate]);

  useEffect(() => {
    if (!allowOutOfSeason) return;

    if (
      Array.isArray(dateRangePicTree) &&
      dateRangePicTree[0] &&
      dateRangePicTree[1]
    ) {
      return;
    }

    const todayStr = moment().tz("Asia/Tokyo").format("YYYY-MM-DD");
    setDateRangePicTree([todayStr, todayStr]);
    setDateRangeValue([todayStr, todayStr]);
  }, [allowOutOfSeason, dateRangePicTree, setDateRangePicTree]);

  useEffect(() => {
    setTimeRangePicTree([startTime, endTime]);
  }, [startTime, endTime]);

  useEffect(() => {
    if (!Array.isArray(dateRangePicTreeMinMax)) return;
    if (allowOutOfSeason) return;

    const [seasonStartRaw, seasonEndRaw] = dateRangePicTreeMinMax;

    // reducer の初期値 [null, null] を弾く
    if (!seasonStartRaw || !seasonEndRaw) return;

    // ここから既存ロジック
    const seasonStart = moment
      .tz(seasonStartRaw, "Asia/Tokyo")
      .startOf("day");
    const seasonEnd = moment
      .tz(seasonEndRaw, "Asia/Tokyo")
      .startOf("day");

    const todayJst = moment().tz("Asia/Tokyo").startOf("day");
    const effectiveEnd = seasonEnd.isAfter(todayJst) ? todayJst : seasonEnd;

    setMinDate(seasonStart.format("YYYY/MM/DD"));
    setMaxDate(effectiveEnd.format("YYYY/MM/DD"));

    if (!maxRange) {
      // maxRange が無いページはそのまま
      setDateRangeValue([
        seasonStart.format("YYYY-MM-DD"),
        effectiveEnd.format("YYYY-MM-DD"),
      ]);
      return;
    }

    let startCandidate = effectiveEnd.clone().subtract(maxRange - 1, "days");
    if (startCandidate.isBefore(seasonStart)) {
      startCandidate = seasonStart.clone();
    }

    const startStr = startCandidate.format("YYYY-MM-DD");
    const endStr = effectiveEnd.format("YYYY-MM-DD");

    setDateRangePicTree([startStr, endStr]);
    setDateRangeValue([startStr, endStr]);
  }, [dateRangePicTreeMinMax, maxRange, setDateRangePicTree]);

  useEffect(() => {
    if (!dateRangePicTree || dateRangePicTree.length < 2) return;

    if (maxRange) {
      setDateRangeValue(dateRangePicTree);
      return;
    }

    if (allowOutOfSeason) {
      setDateRangeValue(dateRangePicTree);
      return;
    }

    if (
      !Array.isArray(dateRangePicTreeMinMax) ||
      !dateRangePicTreeMinMax[1]
    ) {
      setDateRangeValue(dateRangePicTree);
      return;
    }

    const defaultMaxDateFormatted = moment(
      dateRangePicTreeMinMax[1]
    ).format("YYYY-MM-DD");
    const isEndDateAfterToday = moment(today).isBefore(defaultMaxDateFormatted);
    const value = isEndDateAfterToday
      ? [dateRangePicTree[0], todayFormatted]
      : dateRangePicTree;

    setDateRangeValue(value);
  }, [dateRangePicTree, maxRange, dateRangePicTreeMinMax, allowOutOfSeason]);

  const handleHomeCalendar = (currentJstDate) => {
    setDateRangeValue(dateRangePicTree);
  };

  const syncSeasonSelection = (startDate, endDate) => {
    if (!allowOutOfSeason) return;
    if (!Array.isArray(allSeasonData) || allSeasonData.length === 0) {
      setSelectedSeason([]);
      return;
    }

    const rangeStart = moment.tz(`${startDate} 00:00:00`, "Asia/Tokyo");
    const rangeEnd = moment.tz(`${endDate} 23:59:59`, "Asia/Tokyo");

    const matchedSeasons = allSeasonData.filter((season) => {
      const seasonStart = moment.tz(season.seasonStart, "Asia/Tokyo");
      const seasonEnd = moment.tz(season.seasonEnd, "Asia/Tokyo");
      return !rangeEnd.isBefore(seasonStart) && !rangeStart.isAfter(seasonEnd);
    });

    setSelectedSeason(matchedSeasons);
  };

  const setRange = (newValue) => {
    setDateRangeValue(newValue || [null, null]);

    if (
      !newValue ||
      newValue.length < 2 ||
      !newValue[0] ||
      !newValue[1]
    ) {
      return;
    }

    let startMoment = moment(newValue[0]);
    let endMoment = moment(newValue[1]);

    if (maxRange && startMoment.isValid() && endMoment.isValid()) {
      // 日付だけに正規化
      const startDay = startMoment.startOf("day");
      let   endDay   = endMoment.startOf("day");

      const diffDays = endDay.diff(startDay, "days");

      if (diffDays >= maxRange) {
        // ★ Start を基準に End を maxRange-1 日後に調整
        endDay = startDay.clone().add(maxRange - 1, "days");

        // 必要ならシーズンの最終日にクランプ（maxDate の範囲内に収める）
        if (maxDate) {
          const maxDay = moment(maxDate, "YYYY/MM/DD").startOf("day");
          if (endDay.isAfter(maxDay)) {
            endDay = maxDay;
          }
        }
      }

      startMoment = startDay;
      endMoment   = endDay;
    }

    const startDate = startMoment.format("YYYY-MM-DD");
    const endDate   = endMoment.format("YYYY-MM-DD");

    setDateRangePicTree([startDate, endDate]);
    setDateRangeValue([startDate, endDate]);
    syncSeasonSelection(startDate, endDate);
  };

  const fetchData = () => {
    if (currentPage === "/game/pictree/all/point") {
      getPointOverviewDataPicTree();
      getPointTrendDataPicTree();
    } else if (currentPage === "/game/pictree/all/home") {
      getHomePictreeUser();
      getSalesOverviewDataPicTree();
      getPointOverviewDataPicTree();
    } else if (currentPage === "/game/pictree/all/registration") {
      getHomePictreeUser();
      getPictreeDataRegistTrend();
    } else if (currentPage === "/game/pictree/all/reward-coin/ranking") {
      getRewardCoinSummary();
      getRewardCoinRankingData();
    } else if (currentPage === "/game/pictree/all/reward-coin/count-by-coin") {
      getRewardedCoinData();
    } else if (currentPage === "/game/pictree/all/ranking/photo-ranking") {
      getPhotoShootRankingData();
    } else if (currentPage === "/game/pictree/all/ranking/first-photo-ranking") {
      getPhotoFirstShootRankingData();
    } else if (currentPage === "/game/pictree/all/ranking/season-ranking") {
      getSeasonRankingData();
    } else if (currentPage === "/game/pictree/all/ranking/area-ranking") {
      getAreaRankingData();
    } else if (currentPage === "/game/pictree/all/treasure-chest/daily-count") {
      getPicTreeGoldChestTrend();
    } else if (currentPage === "/game/pictree/all/treasure-chest/rainbow-list") {
      getPicTreeRainbowListDetail();
    } else if (currentPage === "/game/pictree/all/review/status") {
      getPicTreeReviewMethodBySeason();
    }
  };

  return (
    <div className={classes.calendarWrapper}>
      <div className={classes.root}>
        <div className={classes.sectionCalendar}>
          <div className={classes.picTreePredefined}>
            <PeriodAll
              singelSelect={singleSelect}
              timeselect={timeselect}
              maxRange={maxRange}
              allowOutOfSeason={allowOutOfSeason}
            />
          </div>
          <DateRangePicker
            startText="Start"
            endText="End"
            disableHighlightToday={true}
            showToolbar={false}
            allowSameDateSelection={true}
            minDate={minDate}
            maxDate={maxDate}
            value={dateRangeValue}
            onChange={(newValue) => setRange(newValue)}
            onError={([startReason, endReason], [start, end]) => {
              if (startReason === "invalidRange") {
                setError([null, null]);
                return;
              }
              setError([startReason, endReason]);
            }}
            shouldDisableDate={(day) => {
              // maxRange 未指定なら制限なし
              if (!maxRange) return false;

              const [start, end] = dateRangeValue || [];
              const dayM   = moment(day).startOf("day");
              const startM = start ? moment(start).startOf("day") : null;
              const endM   = end   ? moment(end).startOf("day")   : null;

              // --- パターン1: Start 済み・End 未選択 → End を選択中 ---
              if (startM && !endM) {
                const diff = dayM.diff(startM, "days");
                // End は Start 以降かつ maxRange 日以内だけ許可
                if (diff < 0) return true;          // Start より前は NG
                if (diff >= maxRange) return true;   // maxRange 超えたら NG
                return false;
              }

              // --- パターン2: End 済み・Start 未選択 → Start を選択中 ---
              if (!startM && endM) {
                const diff = endM.diff(dayM, "days");

                // Start は End 以前かつ maxRange 日以内だけ許可
                if (diff < 0) return true;          // End より後ろは NG
                if (diff > maxRange) return true;   // maxRange 超えたら NG

                return false;
              }

              // --- パターン3: まだどちらも選んでない / 両方選び直し中 ---
              // この場合は制限なし（minDate/maxDate だけ効く）
              return false;
            }}
            renderInput={(startProps, endProps) => (
              <div className={classes.container}>
                <TextField
                  id="standard-basic"
                  {...startProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                  className={classes.dateField}
                />
                {timeselect &&
                <TextField
                  id="start-time"
                  type="time"
                  value={timeRangePicTree[0]}
                  className={classes.timeField}
                  onChange={(e) => setStartTime(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5分刻み
                  }}
                />
                }
                <DateRangeDelimiter>
                  <span className={classes.delimiter}>~</span>
                </DateRangeDelimiter>
                <TextField
                  id="standard-basic"
                  {...endProps}
                  error={Boolean(error[0])}
                  size="small"
                  disabled={page === "pictree-map" ? true : false}
                  helperText=""
                  className={classes.dateField}
                />
                {timeselect &&
                <TextField
                  id="end-time"
                  type="time"
                  value={timeRangePicTree[1]}
                  className={classes.timeField}
                  onChange={(e) => setEndTime(e.target.value)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{
                    step: 300, // 5分刻み
                  }}
                />
                }
              </div>
            )}
          />
          <Button
            className={classes.dataBtn}
            variant="contained"
            color="primary"
            onClick={() => fetchData()}
          >
            GO
          </Button>
        </div>
      </div>
    </div>
  );
};

CalendarRangePickerAll.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  btnStateDataFetch: state.page.btnStateDataFetch,
  dateRangePicTree: state.page.dateRangePicTree,
  timeRangePicTree: state.page.timeRangePicTree,
  dateRangePicTreeMinMax: state.page.dateRangePicTreeMinMax,
  currentPage: state.page.currentPage,
  pictreeView: state.pictree.pictreeView,
  pictreeChartSize: state.pictree.chartSize,
  pictreeMapType: state.pictree.mapType,
  allSeasonData: state.pictree.allSeasonData,
});

const mapDispatchToProps = (dispatch) => ({
  setDateRangePicTree: (param) => dispatch(setDateRangePicTree(param)),
  setSelectedSeason: (param) => dispatch(setSelectedSeason(param)),
  getHomePictreeCheckInNtt: (param) => dispatch(getHomePictreeCheckInNtt(param)),
  getHomePictreePhotoShootNtt: (param) => dispatch(getHomePictreePhotoShootNtt(param)),
  getPictreeDataCheckInTrendNtt: (param) => dispatch(getPictreeDataCheckInTrendNtt(param)),
  getPictreeDataPhotoShootTrendNtt: (param) => dispatch(getPictreeDataPhotoShootTrendNtt(param)),
  getPictreeDataPhotoDenchuKaisuTrend: (param) => dispatch(getPictreeDataPhotoDenchuKaisuTrend(param)),
  getInGameItemSalesByOccurrence: (param) => dispatch(getInGameItemSalesByOccurrence(param)),
  getPhotoShootMapDataNtt: (param) => dispatch(getPhotoShootMapDataNtt(param)),
  getPictreePhotoShootByAssetNtt: (param) => dispatch(getPictreePhotoShootByAssetNtt(param)),
  getPictreePhotoShootTrendByAssetNtt: (param) => dispatch(getPictreePhotoShootTrendByAssetNtt(param)),
  getPointOverviewDataPicTree: (param) => dispatch(getPointOverviewDataPicTree(param)),
  getPointTrendDataPicTree: (param) => dispatch(getPointTrendDataPicTree(param)),
  getRewardCoinSummary: (param) => dispatch(getRewardCoinSummary(param)),
  getRewardCoinRankingData: (param) => dispatch(getRewardCoinRankingData(param)),
  getPhotoShootRankingData: (param) => dispatch(getPhotoShootRankingData(param)),
  getPhotoFirstShootRankingData: (param) => dispatch(getPhotoFirstShootRankingData(param)),
  getSeasonRankingData: (param) => dispatch(getSeasonRankingData(param)),
  getAreaRankingData: (param) => dispatch(getAreaRankingData(param)),
  setTimeRangePicTree: (param) => dispatch(setTimeRangePicTree(param)),
  getPicTreeGoldChestTrend: (param) => dispatch(getPicTreeGoldChestTrend(param)),
  getRewardedCoinData: (param) => dispatch(getRewardedCoinData(param)),
  getPicTreeRainbowListDetail: (param) => dispatch(getPicTreeRainbowListDetail(param)),
  getPicTreeReviewMethodBySeason: (param) => dispatch(getPicTreeReviewMethodBySeason(param)),
  getHomePictreeUser: (param) => dispatch(getHomePictreeUser(param)),
  getPictreeDataRegistTrend: (param) => dispatch(getPictreeDataRegistTrend(param)),
  getSalesOverviewDataPicTree: (param) => dispatch(getSalesOverviewDataPicTree(param)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(CalendarRangePickerAll));
